<template>
  <div class="subscribe-layout" v-if="atuParams && !loading">
    <div class="container">
      <div class="subscribe__page">
        <div class="subscribe__head">
          <div class="logo">
            <img
              v-if="atuParams.atu_logo"
              :src="atuParams.atu_logo"
              :alt="atuParams.atu_motto"
            />
          </div>
          <div class="title">
            <h1>{{ atuParams.atu_motto }}</h1>
          </div>
        </div>
        <div class="subscribe__body"><router-view /></div>
      </div>
      <div v-if="isTestMode" style="text-align: center">
        <h1>TEST MODE</h1>
        <p>route params: {{ $route.params }}</p>
        <p>route meta: {{ $route.meta }}</p>
        <!-- <p>atuParams: {{ atuParams }}</p> -->
        <p>preferences: {{ preferences }}</p>
        <p>getSelfRegUser: {{ getSelfRegUser }}</p>
        <p>getSelfRegUserFound: {{ getSelfRegUserFound }}</p>
      </div>
    </div>
  </div>
  <div v-if="loading" v-loading="true" class="page-loader"></div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "LayoutSubscribe",
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    ...mapGetters({
      atuParams: "getAtuParams",
      isTestMode: "isTestMode",
      preferences: "getPreferences",
      getSelfRegUser: "getSelfRegUser",
      getSelfRegUserFound: "getSelfRegUserFound",
    }),
  },
  methods: {
    ...mapActions(["GET_ATU_PARAMS"]),
  },
  async created() {
    await this.$router.isReady().then(async () => {
      const context_key = this.$route.params.context_key;
      if (context_key) {
        this.$store.commit("MUTATE_SELECTED_ATU", context_key);
        await this.GET_ATU_PARAMS();
      }
    });
    this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
.subscribe {
  &-layout {
    height: 100%;
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 0;
    background: #e2e2e2;
    word-break: break-word;
    &:deep() {
      * {
        word-break: break-word;
      }
    }
  }
  &__head {
    display: flex;
    align-items: center;
    grid-gap: 10px;
    padding: 5px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.42);
    margin: 0 0 15px;
    h1 {
      word-break: break-word;
    }
  }
}
h1 {
  font-size: 18px;
}
.logo {
  max-width: 120px;
  margin: 0;
  display: flex;
  align-items: center;
  img {
    display: block;
    max-width: 100%;
    max-height: 100%;
  }
}
:deep() {
  .page-title {
    text-align: center;
    color: $color-blue;
    margin: 0 0 15px;
  }
  .page-sub-title {
    font-weight: bold;
    margin: 0 0 20px;
    font-size: 14px;
  }
  .step-title {
    color: $color-blue;
    margin: 0 0 15px;
    i {
      font-weight: normal;
    }
  }
  .step-change-box {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid rgba(0, 0, 0, 0.42);
    padding: 1em 0 0;
    &.single {
      justify-content: center;
    }
  }
}
</style>
